<script lang="ts">
    import {Link} from 'svelte-routing'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import star from 'src/components/main/marketplace/components/nft-card/star.svg'
    import plus from 'src/components/main/marketplace/components/nft-card/plus.svg'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import emptyList from './empty.svg'
    import {getNftHistory, buyNft, isConfirmedAction, confirmAction} from 'src/components/main/#services/marketplace'
    import {showAlert} from 'src/components/#common/alert/store'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import {isLoggedIn, userProfile} from 'src/services/auth'
    import {navigate} from 'src/global/navigate'
    import IconifyIcon from '@iconify/svelte'
    import descriptionIcon from '@iconify/icons-fa-solid/file-alt'
    import infoIcon from '@iconify/icons-fa-solid/info-circle'
    import historyIcon from '@iconify/icons-fa-solid/history'
    import {cancelSell, getNft} from 'src/components/cabinet/#services/inventory'
    import {delay} from 'src/global/delay'

    export let productId

    let type
    if (productId.includes("lootbox")) {
        type = 'lootbox'
    } else {
        type = 'unit'
    }

    let code
    let currentPage = 0
    let perPage = 10
    let totalCount = 100
    let buyNftModal = false
    let loading = false

    let rarityList = {
        0: 'Uncommon',
        1: 'Rare',
        2: 'Epic',
        3: 'Legendary',
        4: 'Supreme',
    }

    getNft.reset()
    getNft.send({ data: { productId, type } })

    $: currentPage, productId, update()

    function update() {
        getNft.reset()
        getNftHistory.reset()
        getNft.send({ data: { productId, type } })
        getNftHistory.send({ data: {
            productId,
            page: currentPage + 1,
            perPage
        }})
    }

    function avatar(nickname) {
        if (nickname) {
            return nickname.slice(0, 2)
        }
    }

    function getDate(date) {
        date = new Date(date)
        let year = date.toLocaleString("default", {year: "numeric"})
        let month = date.toLocaleString("default", {month: "2-digit"})
        let day = date.toLocaleString("default", {day: "2-digit"})
        return year+"-"+month+"-"+day
    }

    async function buyNftHandler() {
        try {
            loading = true

            await buyNft.request({ data: { productId: $getNft?.value?.productId } })

            showAlert.set({
                status: 'success',
                text: 'The NFT will be added to your inventory after a few seconds.'
            })

            if ($getNft.hasValue && $getNft.value?.type === 'lootbox') {
                navigate("/inventory/eggs")
            } else if ($getNft.hasValue && $getNft.value?.type === 'unit') {
                navigate("/inventory/units")
            }
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            buyNftModal = false
        }
    }

    async function cancelSellNftHandler() {
        try {
            loading = true

            await cancelSell.request({ data: { productId } })

            showAlert.set({
                status: 'success',
                text: 'NFT sale successfully canceled'
            })

            navigate("/inventory")
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
        }
    }

    async function confirmActionHandler() {
        try {
            loading = true
            await confirmAction.request({data: {code}})
        } catch (err) {
            console.error(err)
        } finally {
            await delay(300)
            loading = false
            isConfirmedAction.reset()
            isConfirmedAction.send()
        }
    }
</script>

<svelte:head>
    {#if !$getNft.hasValue && $getNft.loading}
        <title>Loading...</title>
    {:else if $getNft.hasValue && type === 'lootbox'}
        <title>Egg #{$getNft.value?.productId.split(":")[1]}</title>
    {:else if $getNft.hasValue && type === 'unit'}
        <title>{$getNft.value?.name}</title>
    {:else}
        <title>Something went wrong</title>
    {/if}
    <meta name="description" content=""/>
</svelte:head>

<section class="main-intro">
    <div class="nft-info">
        <div class="container">
            <Link to="marketplace" class="back"><img src="{learnMore}" alt="">Back <span>to Marketplace</span></Link>
            <Alert />
            <div class="row nft-big-card card-{$getNft.value?.rarity}">
                <div class="col-lg-6">
                    <div class="nft-name d-md-none">
                        {#if !$getNft.hasValue && $getNft.loading}
                            Loading...
                        {:else if $getNft.hasValue && $getNft.value?.type === 'lootbox'}
                            Egg #{$getNft.value?.productId.split(":")[1]}
                        {:else if $getNft.hasValue && $getNft.value?.name}
                            {$getNft.value.name}
                        {:else}
                            Something went wrong
                        {/if}
                    </div>
                    <div class="big-image">
                        {#if $getNft.hasValue}
                            {#if $getNft.value?.additionalParams?.image && type === 'unit'}
                                <img src="{$getNft.value.additionalParams.image}" class="nft-img" alt="nft unit">
                            {:else if productId && type === 'lootbox'}
                                <img src="/images/eggs/egg-{productId.slice(-1)}.png" class="nft-img" alt="nft egg">
                            {:else}
                                <img src="https://via.placeholder.com/700x700/transparent" class="nft-img" alt="nft">
                            {/if}
                            {#if $getNft.value?.level}
                                <div class="big-level">LVL.{$getNft.value.level}</div>
                            {/if}
                        {/if}
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="nft-content">
                        <h1 class="nft-name d-none d-md-block">
                            {#if !$getNft.hasValue && $getNft.loading}
                                Loading...
                            {:else if $getNft.hasValue && type === 'lootbox'}
                                Egg #{$getNft.value?.productId.split(":")[1]}
                            {:else if $getNft.hasValue && $getNft.value?.name}
                                {$getNft.value.name}
                            {:else}
                                Something went wrong
                            {/if}
                        </h1>
                        <div class="owner">
                            <div class="avatar">
                                {#if $getNft.hasValue}
                                    {avatar($getNft.value?.nickname)}
                                {/if}
                            </div>
                            {#if !$getNft.hasValue && $getNft.loading}
                                Loading...
                            {:else if !$getNft.hasValue && $getNft.error }
                                Error
                            {:else if $getNft.hasValue && $getNft.value?.nickname}
                                <Link to="marketplace/{$getNft.value?.userId}">
                                    {$getNft.value.nickname.replace(/#([^#]+)$/, '')}
                                </Link>
                            {/if}
                        </div>
                        {#if $getNft.hasValue && $getNft.value?.type === 'unit'}
                            <div class="subtitle">Attributes</div>
                            <div class="nft-border">
                                {#if !$getNft.hasValue && $getNft.loading}
                                    <div class="nft-border-loading">Loading...</div>
                                {:else if $getNft.hasValue}
                                    {#if $getNft.value?.elements && $getNft.value?.elements.length}
                                        <div class="big-elements">
                                            {#each $getNft.value?.elements as item}
                                                {#if item.element}
                                                    <img src="/images/elements/{item.element}-{item.subElement}.svg" alt="{item.element}">
                                                {/if}
                                            {/each}
                                        </div>
                                        <div class="vertical-line"></div>
                                    {/if}
                                    {#if $getNft.value?.rarity}
                                        <div class="big-stars">
                                            {#each {length: $getNft.value.rarity + 2} as _, i}
                                                {#if i < 5}
                                                    <img src="{star}" alt="star">
                                                {/if}
                                            {/each}
                                            {#if $getNft.value.rarity === 4}
                                                <img src="{plus}" class="plus" alt="plus">
                                            {/if}
                                        </div>
                                        <div class="vertical-line"></div>
                                        <div class="rarity-value rarity-id-{$getNft.value.rarity}">
                                            {rarityList[$getNft.value.rarity]}
                                        </div>
                                    {/if}
                                {/if}
                            </div>
                        {/if}
                        {#if $getNft.hasValue && $getNft.value?.additionalParams?.price && $getNft.value?.additionalParams?.currency && $getNft.value?.status === 'inMarket'}
                            <div class="prices">
                                <div class="price"><span>{$getNft.value.additionalParams.price} {$getNft.value.additionalParams.currency}</span></div>
                            </div>
                        {/if}
                        {#if !$getNft.hasValue || $getNft.loading}
                            <button class="buy-btn active-btn" disabled><span>Loading...</span></button>
                        {:else if $isLoggedIn && $getNft.value?.userId === $userProfile.userId && $getNft.value?.status === 'inMarket'}
                            <button class="buy-btn active-btn" on:click={cancelSellNftHandler}
                                disabled={$getNft.loading || loading}><span>Cancel sale</span></button>
                        {:else if $isLoggedIn && $getNft.value?.userId !== $userProfile.userId && $getNft.value?.additionalParams?.price
                            && $getNft.value?.additionalParams?.currency && $getNft.value?.status === 'inMarket'}
                            <button class="buy-btn active-btn" on:click={() => {
                                isConfirmedAction.reset()
                                isConfirmedAction.send()
                                buyNftModal = true
                            }}
                                disabled={$getNft.loading || loading}>
                                <span>Buy for {$getNft.value.additionalParams.price} {$getNft.value.additionalParams.currency}</span>
                            </button>
                        {:else if $getNft.value?.additionalParams?.price && $getNft.value?.additionalParams?.currency && $getNft.value?.status === 'inMarket'}
                            <Link to="login" class="buy-btn active-btn">
                                <span>Buy for {$getNft.value.additionalParams.price} {$getNft.value.additionalParams.currency}</span>
                            </Link>
                        {:else if $getNft.value?.status !== 'inMarket'}
                            <button class="buy-btn active-btn" disabled><span>Not for sale</span></button>
                        {/if}
                        <Modal bind:visible={buyNftModal}>
                            <svelte:fragment slot="content">
                                <div class="modal-custom__title">Buy NFT</div>
                                {#if !$isConfirmedAction.hasValue && $isConfirmedAction.loading}
                                    <div class="modal-custom__text text-center">Loading...</div>
                                {:else if !$isConfirmedAction.hasValue && $isConfirmedAction.error}
                                    <div class="modal-custom__text text-center">Something went wrong. Try refreshing the page.</div>
                                {:else if $isConfirmedAction.hasValue}
                                    {#if !$isConfirmedAction.value}
                                        <div class="modal-custom__text">
                                            <p>We have sent an email confirming the marketplace actions</p>
                                            <div class="text-center">
                                                <div class="form-group mb-3">
                                                    <input type="text" class="form-control confirm-action-field" bind:value={code} placeholder="Enter code">
                                                    <div class="invalid-feedback mt-2" class:d-block={$confirmAction.error}>{$confirmAction.error}</div>
                                                </div>
                                                <button class="btn btn-primary" on:click={confirmActionHandler} class:loading={loading} class:disabled={!code}>
                                                    <span>Confirm</span>
                                                </button>
                                            </div>
                                        </div>
                                    {:else}
                                        <div class="modal-custom__text">
                                            <div class="nft-card card-{$getNft.value?.rarity} egg-card-{type === 'lootbox' && productId ? productId.slice(-1) : ''}"
                                                 style="background: #{$getNft.value?.additionalParams?.backgroundColor};">
                                                {#if $getNft.value?.elements && $getNft.value.elements.length}
                                                    <div class="elements">
                                                        {#each $getNft.value.elements as elem}
                                                            {#if elem.element}
                                                                <img src="/images/elements/{elem.element}-{elem.subElement}.svg" width="40" height="40" alt="{elem.element}">
                                                            {/if}
                                                        {/each}
                                                    </div>
                                                {/if}
                                                {#if $getNft.value?.level}
                                                    <div class="level">
                                                        <span>LVL.{$getNft.value.level}</span>
                                                    </div>
                                                {/if}
                                                <div class="rarity">
                                                    <div class="image">
                                                        {#if $getNft.value?.additionalParams?.image && type === 'unit'}
                                                            <img src="{$getNft.value.additionalParams.image}" class="modal-nft" width="300" height="300" alt="nft unit">
                                                        {:else if productId && type === 'lootbox'}
                                                            <img src="/images/eggs/egg-{productId.slice(-1)}.png" class="modal-nft" width="300" height="300" alt="nft egg">
                                                        {:else}
                                                            <img src="https://via.placeholder.com/300x300/01070A" class="modal-nft" width="300" height="300" alt="nft">
                                                        {/if}
                                                    </div>
                                                    <div class="stars">
                                                        {#if $getNft.value?.rarity}
                                                            {#each {length: $getNft.value.rarity + 2} as _, i}
                                                                {#if i < 5}<img src="{star}" alt="star">{/if}
                                                            {/each}
                                                            {#if $getNft.value.rarity === 4}
                                                                <img src="{plus}" class="plus" alt="plus">
                                                            {/if}
                                                        {/if}
                                                    </div>
                                                </div>
                                                <div class="wrapper">
                                                    <div class="name" class:no-stars={!$getNft.value?.rarity}>
                                                        {#if $getNft.hasValue && $getNft.value?.type === 'lootbox'}
                                                            Egg
                                                        {:else if $getNft.hasValue && $getNft.value?.name}
                                                            {$getNft.value.name}
                                                        {/if}
                                                        {#if productId}
                                                            <div class="id">#{productId.replace(/\D/g, "")}</div>
                                                        {/if}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-custom__footer">
                                            <button class="btn btn-cancel" on:click={() => { buyNftModal = false }} disabled={loading}>Cancel</button>
                                            <button class="btn btn-primary" class:loading={loading} on:click={buyNftHandler} disabled={loading}><span>Confirm</span></button>
                                        </div>
                                    {/if}
                                {/if}
                            </svelte:fragment>
                        </Modal>
                    </div>
                </div>
            </div>
            <div class="row nft-page-info">
                <div class="col-lg-6">
                    {#if type === 'unit'}
                        <div class="tab">
                            <IconifyIcon icon={descriptionIcon} class="tab-icon"/>Description
                        </div>
                        <div class="description">
                            {#if !$getNft.hasValue && $getNft.loading}
                                Loading...
                            {:else if $getNft.hasValue}
                                The NFT "{#if $getNft.value?.name}{$getNft.value.name}{:else}Egg #{$getNft.value?.productId.split(":")[1]}{/if}" belongs to the {$getNft.value.collection} collection and has level {$getNft.value?.level ? $getNft.value.level : 1}. {#if $getNft.value?.rarity}This item has {$getNft.value.rarity + 2 > 5 ? 5 : $getNft.value.rarity + 2}{#if $getNft.value?.rarity === 4}+{/if} stars and its rarity is {rarityList[$getNft.value.rarity]}.{/if}
                            {/if}
                        </div>
                    {/if}
                    <div class="tab">
                        <IconifyIcon icon={infoIcon} class="tab-icon"/>Information
                    </div>
                    <div class="description">
                        {#if !$getNft.hasValue && $getNft.loading}
                            {#if type === 'unit'}
                                <p>Collection: Loading...</p>
                            {/if}
                            <p>Type: Loading...</p>
                            <p>Rarity: Loading...</p>
                            <p>Stars: Loading...</p>
                            <p>Level: Loading...</p>
                        {:else if $getNft.hasValue}
                            {#if type === 'unit'}
                                <p>Collection: <span class="first-letter">{$getNft.value.collection}</span></p>
                            {/if}
                            <p>Type: <span class="first-letter">{$getNft.value.type === 'lootbox' ? 'Egg' : $getNft.value.type}</span></p>
                            {#if $getNft.value?.rarity}
                                <p>Rarity: {rarityList[$getNft.value.rarity]}</p>
                                <p>Stars: {$getNft.value.rarity + 2 > 5 ? 5 : $getNft.value.rarity + 2}{#if $getNft.value?.rarity === 4}+{/if}</p>
                            {/if}
                            {#if $getNft.value?.level}
                                <p>Level: {$getNft.value.level}</p>
                            {/if}
                        {/if}
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="history-column">
                        <div class="tab">
                            <IconifyIcon icon={historyIcon} class="tab-icon"/>History
                        </div>
                        {#if !$getNftHistory.hasValue && $getNftHistory.loading}
                            <div class="description">Loading...</div>
                        {:else if !$getNftHistory.hasValue && $getNftHistory.error}
                            <div class="description">Something went wrong</div>
                        {:else if $getNftHistory.hasValue}
                            {#if $getNftHistory.value.totalCount}
                                <div class="history-table">
                                    <div class="history-table-header">
                                        <div>Price</div>
                                        <div>Owner</div>
                                        <div>Date</div>
                                    </div>
                                    <div class="history-table-body">
                                        {#each $getNftHistory.value.items as {price, currency, userId, nickname, createdAt}}
                                            <div class="history-table-row">
                                                <div>{price} {currency}</div>
                                                <div><Link to="marketplace/{userId}">{nickname.replace(/#([^#]+)$/, '')}</Link></div>
                                                <div>{getDate(createdAt).toLocaleString()}</div>
                                            </div>
                                        {/each}
                                    </div>
                                </div>
                                <div class="text-center">
                                    <Pagination bind:currentPage={currentPage} totalCount={$getNftHistory.value?.totalCount} {perPage} disabled={!$getNftHistory.hasValue && $getNftHistory.loading}/>
                                </div>
                            {:else}
                                <div class="content-empty">
                                    <div class="title">No data yet</div>
                                    <img src="{emptyList}" alt="">
                                </div>
                            {/if}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .main-intro {
        position: relative;
        padding-top: 110px;
    }

    .owner {
        margin: 0 0 40px;
        font-size: 20px;
        display: flex;
        align-items: center;
        color: white;
        font-weight: 500;
    }

    .first-letter {
        text-transform: capitalize;
    }

    .history-column {
        padding-left: 28px;
    }

    .owner .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #282d39;
        margin-right: 12px;
        color: #e9e5e5;
        font-size: 13px;
        text-transform: uppercase;
        cursor: default;
    }

    .nft-content .owner :global(a){
        color: white;
        font-weight: 500;
        text-decoration: none;
        transition: .15s;
    }

    .nft-content .owner :global(a:hover){
        color: #FF5D1C;
    }

    .big-image {
        background: linear-gradient(180deg, #3E2929 -72.66%, #0B0E21 132.58%);
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 5px;
        border: 1px solid white;
    }

    .tabs .tab :global(.tab-icon) {
        margin-right: 8px;
    }

    .label {
        background: #AAAAAA;
        color: white;
        border-radius: 3px;
        padding: 7px 10px;
        line-height: normal;
        font-size: 14px;
        font-weight: 500;
        text-transform: capitalize;
    }

    .big-level {
        font-size: 25px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 1.3;
        position: absolute;
        top: 20px;
        right: 20px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .nft-img {
        position: relative;
        width: 100%;
        height: 100%;
        max-height: 530px;
        max-width: 530px;
        object-fit: contain;
        padding: 60px;
        transform: matrix3d(1,-.03,0,.0004,.03,1,-.05,0,0,.05,1,0,5,0,-20,1) scale(0.95);
        transition: .5s;
    }

    .nft-img:hover {
        transform: matrix3d(1,.03,0,-.0004,-.03,1,.05,0,0,-.05,1,0,-5,0,20,1) scale(1.05);
    }

    .nft-img:before {
        content: "";
        width: 100px;
        height: 100px;
        position: absolute;
        z-index: 1;
        background: #ffffff;
        filter: blur(30px);
        opacity: 0.15;
    }

    .nft-mini-img {
        width: 180px;
        height: 180px;
        margin: 0 auto 20px;
        display: block;
        background: #41485e;
        border-radius: 5px;
        padding: 10px;
    }

    .nft-mini-img img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .nft-info :global(.back) {
        color: white;
        font-size: 20px;
        font-family: 'Anton', sans-serif;
        margin: 50px 0;
        display: table;
        text-decoration: none;
        text-transform: uppercase;
    }

    .nft-info :global(.back img) {
        margin-right: 10px;
        transform: rotate(-90deg);
        transition: .25s;
    }

    .nft-info :global(.back:hover img) {
        transform: rotate(-135deg);
    }

    .big-id {
        font-size: 18px;
        color: white;
        background: #282D39;
        border-radius: 3px;
        padding: 10px;
        position: absolute;
        top: 28px;
        right: 28px;
        line-height: normal;
        cursor: default;
    }

    .nft-name {
        font-size: 40px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 60px;
        margin-bottom: 20px;
    }

    .nft-content {
        padding: 30px;
        background: #0d1418;
        border-radius: 5px;
        margin-left: 16px;
    }

    .nft-big-card {
        margin-bottom: 30px;
    }

    .description {
        font-size: 16px;
        color: white;
        line-height: 24px;
        font-weight: 300;
        margin: 10px 0 30px 0;
    }

    .description p {
        margin-bottom: 10px;
    }

    .subtitle {
        font-size: 20px;
        font-weight: 600;
        color: white;
        margin-bottom: 20px;
    }

    .nft-border {
        border: 1px solid #FF5D1C;
        border-radius: 20px;
        padding: 25px 25px 0;
        margin-bottom: 42px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        cursor: default;
    }

    .nft-border-loading {
        margin-bottom: 25px;
        text-align: center;
        width: 100%;
        color: white;
    }

    .nft-border > * {
        margin-bottom: 25px !important;
    }

    .big-stars img {
        width: 30px;
        height: 30px;
        margin: 0 2px;
    }

    .big-stars .plus {
        width: 18px;
        height: 18px;
        margin-left: -1px;
    }

    .vertical-line {
        width: 1px;
        min-width: 1px;
        height: 50px;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
        margin: 0 20px;
    }

    .price {
        color: #A0AEC0;
        font-size: 20px;
        line-height: 50px;
    }

    .price span {
        color: #FFDB3A;
        font-size: 50px;
        font-weight: 900;
        margin-right: 10px;
    }

    .prices {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 10px;
    }

    :global(.buy-btn) {
        background: #FF5D1C;
        color: white;
        border: 0;
        height: 70px;
        width: 100%;
        border-radius: 3px;
        text-transform: uppercase;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        letter-spacing: 1px;
        transition: .25s;
    }

    :global(.buy-btn:hover) {
        background: #fb7844;
        color: white;
        text-decoration: none;
    }

    .big-elements img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
    }

    .big-elements img:last-child {
        margin-right: 0;
    }

    .rarity-value {
        padding: 10px 15px;
        position: relative;
        color: white;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 500;
    }

    .rarity-id-0 {
        background: #66DC96;
    }

    .rarity-id-1 {
        background: #434ACF;
    }

    .rarity-id-2 {
        background: #B644D3;
    }

    .rarity-id-3 {
        background: #FAC50E;
    }

    .rarity-id-4 {
        background: #CF4343;
    }

    .card-common .image {
        border-color: #E6E6E6;
    }

    .card-common .label {
        background: #AAAAAA;
    }

    .card-legendary .backdrop {
        background: rgba(255, 156, 0, 0.25);
    }

    .card-legendary .image {
        border-color: #F0A500;
    }

    .card-legendary .label {
        background: #F0A500;
    }

    .card-uncommon .backdrop {
        background: rgba(39, 174, 96, 0.25);
    }

    .card-uncommon .label {
        background: #27AE60;
    }

    .card-uncommon .image {
        border-color: #27AE60;
    }

    .card-epic .label {
        background: #9B51E0;
    }

    .card-epic .backdrop {
        background: rgba(155, 81, 224, 0.25);
    }

    .card-epic .image {
        border-color: #9B51E0;
    }

    .card-epic .label {
        background: #9B51E0;
    }

    .card-rare .label {
        background: #2F80ED;
    }

    .card-rare .backdrop {
        background: rgba(47, 128, 237, 0.25);
    }

    .card-rare .image {
        border-color: #2F80ED;
    }

    .card-rare .label {
        background: #2F80ED;
    }

    .card-relic .label {
        background: linear-gradient(153.33deg, #FF61F6 0%, #FFF61C 176.46%);
    }

    .card-relic .backdrop {
        background: rgba(255, 146, 173, 0.25);
    }

    .card-relic .image {
        border-color: #ff92af;
    }

    .tab {
        font-size: 20px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 26px;
        font-weight: 400;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        padding: 10px 10px 10px 0;
    }

    .nft-page-info :global(.tab-icon) {
        margin-right: 10px;
    }

    .big-stars {
        white-space: nowrap;
    }

    .history-table {
        margin: 10px auto 15px;
        max-width: 1174px;
    }

    .history-table-header {
        display: flex;
        width: 100%;
        background: #cad5e0;
        border-radius: 8px 8px 0 0;
    }

    .history-table-header > div {
        width: 33.3%;
        padding: 10px 30px;
        background: #CAD5E0;
        color: #272C33;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
    }

    .history-table-header > div:first-child {
        border-radius: 8px 0 0 0;
    }

    .history-table-header > div:last-child {
        border-radius: 0 8px 0 0;
    }

    .history-table-row {
        border: 1px solid #CAD5E0;
        border-bottom: 0;
        border-radius: 0;
        display: flex;
        width: 100%;
    }

    .history-table-row:last-child {
        border-bottom: 1px solid #CAD5E0;
        border-radius: 0 0 8px 8px;
    }

    .history-table-row > div {
        width: 33.3%;
        padding: 10px 30px;
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
        color: white;
    }

    .history-table-row :global(a) {
        color: white;
        text-decoration: none;
        text-overflow: ellipsis;
        overflow: hidden;
        transition: .15s;
    }

    .history-table-row :global(a:hover) {
        color: #fb7844;
    }

    .history-column :global(.pagination) {
        justify-content: center;
    }

    .content-empty {
        width: 100%;
        text-align: center;
        padding: 50px 0;
    }

    .content-empty .title {
        color: #b4c1cf;
        font-size: 18px;
        margin: 0 0 20px;
    }

    .content-empty img {
        max-width: 160px;
    }

    .buy-btn[disabled],
    .buy-btn[disabled]:hover {
        background: #fb7844;
        opacity: 0.7;
    }






    .wrapper {
        padding: 15px;
        box-shadow: 0 -3px 0 0 rgba(0, 0, 0, 0.25) inset;
        border-radius: 0 0 8px 8px;
        background: rgba(119, 132, 151, .5);
    }

    .elements {
        position: absolute;
        left: 15px;
        top: 15px;
        z-index: 2;
    }

    .elements img:not(:first-child) {
        margin-left: -10px;
    }

    .level {
        position: absolute;
        right: -2px;
        top: -2px;
        font-size: 15px;
        font-family: 'Anton', sans-serif;
        color: white;
        padding: 5px 18px;
        line-height: normal;
        border: 2px solid white;
        border-radius: 0 8px 0 8px;
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.5) inset;
        text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    }

    .stars {
        text-align: center;
        margin-top: -10px;
        height: 32px;
        margin-bottom: 15px;
    }

    .stars img:not(:first-child) {
        margin-left: 5px;
    }

    .image {
        margin-top: 15px;
        text-align: center;
    }

    .image img {
        max-width: 100%;
        max-height: 300px;
        height: auto;
    }

    .name {
        font-size: 25px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: normal;
        text-shadow: 2px 0 0 #000, -2px 0 0 #000, 0 2px 0 #000, 0 -2px 0 #000, 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;
        position: relative;
        margin-bottom: 5px;
    }

    .id {
        font-size: 18px;
        position: absolute;
        right: 0;
        bottom: 2px;
    }

    .modal-custom__text .nft-card {
        max-width: 340px;
        margin: 0 auto;
        zoom: .7;
    }

    .modal-custom__text .nft-card:hover {
        transform: none;
        box-shadow: none;
    }

    .modal-custom__footer {
        display: flex;
    }

    .modal-custom__footer .btn:first-child {
        margin-left: 0;
    }

    .modal-custom__footer .btn {
        width: 50%;
    }

    .form-control.confirm-action-field {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
        padding: 10px 15px;
        margin: 0 auto;
        text-align: center;
        max-width: 200px;
        border-radius: 8px;
    }

    .form-control.confirm-action-field:focus {
        box-shadow: none;
    }

    .form-control.confirm-action-field:focus {
        border-color: #FF5D1C;
    }

    @media(max-width: 767px) {
        :global(.nft-card:hover) {
            transform: none;
            box-shadow: none;
        }

        .modal-custom__footer .btn {
            padding: 12px 6px;
        }
    }

    @media(max-width: 1400px) {
        .price span {
            font-size: 46px;
        }

        .big-stars img {
            width: 26px;
            margin: 0 2px;
        }

        .vertical-line {
            margin: 0 15px;
        }

        .big-level {
            font-size: 22px;
        }
    }

    @media(max-width: 1199px) {
        .nft-img {
            max-width: 320px;
            max-height: 320px;
        }

        .description {
            margin-bottom: 30px;
        }

        .nft-border {
            padding: 20px 20px 0;
            margin-bottom: 50px;
        }

        .nft-border-loading {
            margin-bottom: 20px !important;
        }

        .vertical-line {
            margin: 0 15px;
            min-width: 1px;
            width: 1px;
        }

        .big-stars img {
            width: 22px;
            margin: 0 2px;
        }

        .nft-name {
            font-size: 36px;
            line-height: 50px;
        }

        .price span {
            font-size: 36px;
        }

        .price {
            font-size: 18px;
        }

        :global(.buy-btn) {
            height: 54px;
        }

        .prices {
            margin-bottom: 30px;
        }

        .history-table-row > div {
            padding: 10px;
            font-size: 14px;
        }

        .history-table-header > div {
            padding: 10px;
            font-size: 15px;
        }
    }

    @media(max-width: 991px) {
        .nft-info :global(.back) {
            margin: 40px 0;
        }

        .nft-content {
            padding-left: 30px;
            margin: 20px 0 0;
        }

        .nft-img {
            max-width: 300px;
            max-height: 300px;
        }

        .nft-border {
            margin-bottom: 40px;
        }

        .big-id {
            padding: 6px 8px;
        }

        .history-column {
            padding-left: 0;
        }
    }

    @media(max-width: 767px) {
        .big-image {
            height: calc(100vw - 24px);
            width: 100%;
        }

        .nft-img {
            max-width: 100%;
            max-height: 100%;
            padding: 25px;
            transform: none;
        }

        .nft-name {
            font-size: 30px;
            line-height: 45px;
        }

        .nft-info :global(.back) {
            margin: 30px 0;
        }

        .nft-info :global(.back span) {
            display: none;
        }

        .nft-border {
            flex-wrap: wrap;
            padding-bottom: 10px;
        }

        .nft-border > * {
            margin-bottom: 10px;
        }

        .main-intro {
            padding-top: 62px;
        }

        .big-id {
            font-size: 14px;
            top: 12px;
            right: 12px;
        }

        .prices {
            flex-wrap: wrap;
            flex-direction: column-reverse;
            justify-content: flex-start;
            align-items: flex-start;
            margin-bottom: 20px;
        }

        .price {
            font-size: 15px;
            flex-wrap: wrap;
            line-height: 36px;
        }

        .price span {
            font-size: 30px;
        }

        .big-level {
            font-size: 20px;
        }

        .vertical-line {
            height: 32px;
        }

        .tabs {
            padding-top: 30px;
            flex-wrap: wrap;
        }

        .tab:not(:last-child) {
            margin-right: 20px;
        }

        .tab-content {
            font-size: 14px;
            line-height: 21px;
            padding-bottom: 30px;
            margin-bottom: 50px;
        }

        .nft-content {
            padding: 15px;
        }

        :global(.buy-btn) {
            letter-spacing: 0;
        }

        .content-empty .title {
            font-size: 16px;
        }

        .content-empty img {
            max-width: 140px;
        }

        .nft-border {
            padding: 15px 15px 0;
        }

        .nft-border > * {
            margin-bottom: 15px !important;
        }

        .big-elements img {
            width: 30px;
            height: 30px;
        }

        .rarity-value {
            padding: 6px 10px;
            font-size: 14px;
        }

        .nft-img:hover {
            transform: none;
        }
    }
</style>
